import script from "./TechnologyAssetsComparisonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsComparisonView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__